import { Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openSnack } from "../redux/globalStates";

export default function Snackback() {
  const dispatch = useDispatch();

  const { snackbarOpen, snackbarMessage } = useSelector(
    (state) => state.globalStates
  );
  const close = () => dispatch(openSnack());
  return (
    <div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={7000}
        onClose={close}
        message={snackbarMessage}
      />
    </div>
  );
}
